import React, { Fragment, useEffect, forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import Title from 'antd/es/typography/Title';
import { getModeName } from 'lib';
import { useSpring, animated } from 'react-spring'

export default forwardRef((props: any, ref: any) => {
  const { inputData, language, checkAnswer, } = props,
    { questions } = inputData;
  const composeMode = getModeName() === "compose";
  const options = useSpring({ delay: 2000, to: { opacity: 1 }, from: { opacity: 0 } });

  return (
    <Fragment>
      <Title level={4} style={{
          textAlign: "center", margin: "0px 8vw 0px 8vw",
          wordBreak: "break-word", textAlign: "center",
        }}>
        {
          checkAnswer || composeMode ?
          <animated.div style={options}>
            <span dangerouslySetInnerHTML={{
                __html: questions[language] || "no question for selected language"
              }}
            />
          </animated.div> :
          null
        }
      </Title>
    </Fragment>
  );
});
